webpackJsonp([4],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(268);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _apiRunnerBrowser = __webpack_require__(326);
	
	var _apiRunnerBrowser2 = _interopRequireDefault(_apiRunnerBrowser);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(24);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _applyRouterMiddleware = __webpack_require__(225);
	
	var _applyRouterMiddleware2 = _interopRequireDefault(_applyRouterMiddleware);
	
	var _Router = __webpack_require__(223);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	var _match = __webpack_require__(230);
	
	var _match2 = _interopRequireDefault(_match);
	
	var _browserHistory = __webpack_require__(226);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _useScroll = __webpack_require__(551);
	
	var _useScroll2 = _interopRequireDefault(_useScroll);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	// Let the site/plugins run code very early.
	(0, _apiRunnerBrowser2.default)('clientEntry');
	
	// Explicitly require from Gatsby subfolder. This isn't normally required but
	// seems to be when developing using "npm link" as otherwise Webpack uses
	// different versions of the plugin (one locally and the other in the checked
	// out version of Gatsby) which makes everything fall apart.
	var runtime = void 0;
	try {
	  runtime = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"gatsby/node_modules/offline-plugin/runtime\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	} catch (e) {
	  // If the above doesn't work, require normally.
	  try {
	    runtime = __webpack_require__(459);
	  } catch (e) {
	    // ignore
	  }
	}
	
	// Install service worker.
	runtime.install({
	  onInstalled: function onInstalled() {
	    console.log("SW Event:", "onInstalled");
	  },
	  onUpdating: function onUpdating() {
	    console.log("SW Event:", "onUpdating");
	  },
	  onUpdateReady: function onUpdateReady() {
	    console.log("SW Event:", "onUpdateReady");
	    runtime.applyUpdate();
	  },
	  onUpdated: function onUpdated() {
	    console.log("SW Event:", "onUpdated");
	    (0, _apiRunnerBrowser2.default)('swOnUpdated');
	  },
	  onUninstalled: function onUninstalled() {
	    console.log("SW Event:", "onUninstalled");
	  }
	});
	
	var rootElement = document.getElementById('react-mount');
	var rootRoute = __webpack_require__(255);
	
	// If you try to load the split-child-routes module in other
	// modules, Webpack freezes in some sort of infinite loop when
	// you try to build the javascript for production. No idea
	// why... so for now we'll pop the routes on window. I hope no
	// one feels overly dirty from reading this ;-)
	if (typeof window !== 'undefined') {
	  window.gatsbyRootRoute = rootRoute;
	}
	
	var currentLocation = void 0;
	_browserHistory2.default.listen(function (location) {
	  currentLocation = location;
	});
	
	function shouldUpdateScroll(prevRouterProps, _ref) {
	  var pathname = _ref.location.pathname;
	
	  if (prevRouterProps) {
	    var oldPathname = prevRouterProps.location.pathname;
	
	    if (oldPathname === pathname) {
	      return false;
	    }
	  }
	  return true;
	}
	
	(0, _match2.default)({ history: _browserHistory2.default, routes: rootRoute }, function (error, redirectLocation, renderProps) {
	  var Root = function Root() {
	    return _react2.default.createElement(_Router2.default, (0, _extends3.default)({}, renderProps, {
	      render: (0, _applyRouterMiddleware2.default)((0, _useScroll2.default)(shouldUpdateScroll)),
	      onUpdate: function onUpdate() {
	        (0, _apiRunnerBrowser2.default)('onRouteUpdate', currentLocation);
	      }
	    }));
	  };
	  var NewRoot = (0, _apiRunnerBrowser2.default)('wrapRootComponent', { Root: Root }, Root);
	  _reactDom2.default.render(_react2.default.createElement(NewRoot, null), typeof window !== 'undefined' ? document.getElementById('react-mount') : void 0);
	});

/***/ },

/***/ 255:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootRoute = { childRoutes: [{
	    path: '/blog/',
	    component: __webpack_require__(263),
	    indexRoute: {
	      getComponent: function getComponent(nextState, cb) {
	        __webpack_require__.e/* nsure */(1, function (require) {
	          var Component = __webpack_require__(147);
	          if (Component.default) {
	            Component = Component.default;
	          }
	          __webpack_require__.e/* nsure */(5, function (require) {/* WEBPACK VAR INJECTION */(function(Glamor) {
	            var data = __webpack_require__(170);
	            cb(null, function () {
	              return Glamor.createElement(Component, _extends({}, nextState, data));
	            });
	          
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)))});
	        });
	      }
	    },
	
	    childRoutes: [{
	      path: '/blog/01-03-2017-Three+Reasons+Why+Speed+Is+Top+Priority/',
	      getComponent: function getComponent(nextState, cb) {
	        __webpack_require__.e/* nsure */(0, function (require) {
	          var Component = __webpack_require__(84);
	          if (Component.default) {
	            Component = Component.default;
	          }
	          __webpack_require__.e/* nsure */(7, function (require) {/* WEBPACK VAR INJECTION */(function(Glamor) {
	            var data = __webpack_require__(343);
	            cb(null, function () {
	              return Glamor.createElement(Component, _extends({}, nextState, data));
	            });
	          
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)))});
	        });
	      }
	    }, {
	      path: '/blog/01-02-2017-Our+Favorite+Design+Products/',
	      getComponent: function getComponent(nextState, cb) {
	        __webpack_require__.e/* nsure */(0, function (require) {
	          var Component = __webpack_require__(84);
	          if (Component.default) {
	            Component = Component.default;
	          }
	          __webpack_require__.e/* nsure */(8, function (require) {/* WEBPACK VAR INJECTION */(function(Glamor) {
	            var data = __webpack_require__(342);
	            cb(null, function () {
	              return Glamor.createElement(Component, _extends({}, nextState, data));
	            });
	          
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)))});
	        });
	      }
	    }, {
	      path: '/blog/01-01-2017-Introducing-Krasa--Mobile-App-Web-Design-Development/',
	      getComponent: function getComponent(nextState, cb) {
	        __webpack_require__.e/* nsure */(0, function (require) {
	          var Component = __webpack_require__(84);
	          if (Component.default) {
	            Component = Component.default;
	          }
	          __webpack_require__.e/* nsure */(9, function (require) {/* WEBPACK VAR INJECTION */(function(Glamor) {
	            var data = __webpack_require__(341);
	            cb(null, function () {
	              return Glamor.createElement(Component, _extends({}, nextState, data));
	            });
	          
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)))});
	        });
	      }
	    }, {
	      path: '/blog/',
	      getComponent: function getComponent(nextState, cb) {
	        __webpack_require__.e/* nsure */(1, function (require) {
	          var Component = __webpack_require__(147);
	          if (Component.default) {
	            Component = Component.default;
	          }
	          __webpack_require__.e/* nsure */(5, function (require) {/* WEBPACK VAR INJECTION */(function(Glamor) {
	            var data = __webpack_require__(170);
	            cb(null, function () {
	              return Glamor.createElement(Component, _extends({}, nextState, data));
	            });
	          
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)))});
	        });
	      }
	    }, {
	      path: '/',
	      getComponent: function getComponent(nextState, cb) {
	        __webpack_require__.e/* nsure */(3, function (require) {
	          var Component = __webpack_require__(264);
	          if (Component.default) {
	            Component = Component.default;
	          }
	          __webpack_require__.e/* nsure */(6, function (require) {/* WEBPACK VAR INJECTION */(function(Glamor) {
	            var data = __webpack_require__(344);
	            cb(null, function () {
	              return Glamor.createElement(Component, _extends({}, nextState, data));
	            });
	          
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)))});
	        });
	      }
	    }] }] };
	module.exports = rootRoute;

/***/ },

/***/ 261:
/***/ function(module, exports) {

	"use strict";
	
	exports.onRouteUpdate = function (location) {
	  // Only track in production
	  console.log(window.location);
	  if (typeof window.mixpanel !== 'undefined' && window.location.host.match(/krasadev/)) {
	    window.mixpanel.track("Page View: " + location.pathname);
	  }
	};

/***/ },

/***/ 263:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colors = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import '../css/prism-coy.css'
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, (Template.__proto__ || Object.getPrototypeOf(Template)).apply(this, arguments));
	  }
	
	  _createClass(Template, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          location = _props.location,
	          children = _props.children;
	
	      return Glamor.createElement(
	        'div',
	        {
	          style: { background: _colors.colors.snow }
	        },
	        children
	      );
	    }
	  }]);
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _react2.default.PropTypes.any,
	  location: _react2.default.PropTypes.object,
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = Template;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ },

/***/ 267:
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(272), __esModule: true };

/***/ },

/***/ 268:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(267);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },

/***/ 272:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(298);
	module.exports = __webpack_require__(148).Object.assign;

/***/ },

/***/ 273:
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },

/***/ 274:
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(89);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },

/***/ 275:
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(152)
	  , toLength  = __webpack_require__(294)
	  , toIndex   = __webpack_require__(293);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },

/***/ 276:
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },

/***/ 148:
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },

/***/ 277:
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(273);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },

/***/ 149:
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },

/***/ 86:
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(87)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },

/***/ 278:
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(89)
	  , document = __webpack_require__(88).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },

/***/ 279:
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },

/***/ 280:
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(88)
	  , core      = __webpack_require__(148)
	  , ctx       = __webpack_require__(277)
	  , hide      = __webpack_require__(282)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },

/***/ 87:
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },

/***/ 88:
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },

/***/ 281:
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },

/***/ 282:
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(285)
	  , createDesc = __webpack_require__(290);
	module.exports = __webpack_require__(86) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },

/***/ 283:
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(86) && !__webpack_require__(87)(function(){
	  return Object.defineProperty(__webpack_require__(278)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },

/***/ 150:
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(276);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },

/***/ 89:
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },

/***/ 284:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(288)
	  , gOPS     = __webpack_require__(286)
	  , pIE      = __webpack_require__(289)
	  , toObject = __webpack_require__(295)
	  , IObject  = __webpack_require__(150)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(87)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },

/***/ 285:
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(274)
	  , IE8_DOM_DEFINE = __webpack_require__(283)
	  , toPrimitive    = __webpack_require__(296)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(86) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },

/***/ 286:
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },

/***/ 287:
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(281)
	  , toIObject    = __webpack_require__(152)
	  , arrayIndexOf = __webpack_require__(275)(false)
	  , IE_PROTO     = __webpack_require__(291)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },

/***/ 288:
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(287)
	  , enumBugKeys = __webpack_require__(279);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },

/***/ 289:
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },

/***/ 290:
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },

/***/ 291:
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(292)('keys')
	  , uid    = __webpack_require__(297);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },

/***/ 292:
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(88)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },

/***/ 293:
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(151)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },

/***/ 151:
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },

/***/ 152:
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(150)
	  , defined = __webpack_require__(149);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },

/***/ 294:
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(151)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },

/***/ 295:
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(149);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },

/***/ 296:
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(89);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },

/***/ 297:
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },

/***/ 298:
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(280);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(284)});

/***/ },

/***/ 326:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var gatsbyBrowser = void 0;
	try {
	  gatsbyBrowser = __webpack_require__(261);
	  console.log('gatsbyBrowser', gatsbyBrowser);
	} catch (e) {
	  if (e.toString().indexOf('gatsby-browser') !== -1) {
	    console.log('Couldn\'t open your gatsby-browser.js file');
	    console.log(e);
	  }
	}
	module.exports = function (api, args, defaultReturn) {
	  if (gatsbyBrowser && gatsbyBrowser[api]) {
	    var result = gatsbyBrowser[api](args);
	    // Internal caller of apiRunner should specify whether a return value
	    // is required or not.
	    //if (!result) {
	    //throw new Error(`The API "${api}" in gatsby-browser.js did not return a value`)
	    //process.exit()
	    //}
	    return result;
	  }
	
	  return defaultReturn;
	};

/***/ },

/***/ 459:
/***/ function(module, exports) {

	var appCacheIframe;
	
	function hasSW() {
	  return 'serviceWorker' in navigator &&
	    // This is how I block Chrome 40 and detect Chrome 41, because first has
	    // bugs with history.pustState and/or hashchange
	    (window.fetch || 'imageRendering' in document.documentElement.style) &&
	    (window.location.protocol === 'https:' || window.location.hostname === 'localhost')
	}
	
	function install(options) {
	  options || (options = {});
	
	  
	    if (hasSW()) {
	      var registration = navigator.serviceWorker
	        .register(
	          "/sw.js"
	          
	        );
	
	      
	        var handleUpdating = function(registration) {
	          var sw = registration.installing || registration.waiting;
	          var ignoreInstalling;
	          var ignoreWaiting;
	
	          // No SW or already handled
	          if (!sw || sw.onstatechange) return;
	
	          var stateChangeHandler;
	
	          // Already has SW
	          if (registration.active) {
	            onUpdateStateChange();
	            stateChangeHandler = onUpdateStateChange;
	          } else {
	            onInstallStateChange();
	            stateChangeHandler = onInstallStateChange;
	          }
	
	          ignoreInstalling = true;
	          if (registration.waiting) {
	            ignoreWaiting = true;
	          }
	
	          sw.onstatechange = stateChangeHandler;
	
	          function onUpdateStateChange() {
	            switch (sw.state) {
	              case 'redundant': {
	                sendEvent('onUpdateFailed');
	                sw.onstatechange = null;
	              } break;
	
	              case 'installing': {
	                if (!ignoreInstalling) {
	                  sendEvent('onUpdating');
	                }
	              } break;
	
	              case 'installed': {
	                if (!ignoreWaiting) {
	                  sendEvent('onUpdateReady');
	                }
	              } break;
	
	              case 'activated': {
	                sendEvent('onUpdated');
	                sw.onstatechange = null;
	              } break;
	            }
	          }
	
	          function onInstallStateChange() {
	            switch (sw.state) {
	              case 'redundant': {
	                // Failed to install, ignore
	                sw.onstatechange = null;
	              } break;
	
	              case 'installing': {
	                // Installing, ignore
	              } break;
	
	              case 'installed': {
	                // Installed, wait activation
	              } break;
	
	              case 'activated': {
	                sendEvent('onInstalled');
	                sw.onstatechange = null;
	              } break;
	            }
	          }
	        };
	
	        var sendEvent = function(event) {
	          if (typeof options[event] === 'function') {
	            options[event]({
	              source: 'ServiceWorker'
	            });
	          }
	        };
	
	        registration.then(function(reg) {
	          // WTF no reg?
	          if (!reg) return;
	
	          // Installed but Shift-Reloaded (page is not controller by SW),
	          // update might be ready at this point (more than one tab opened).
	          // Anyway, if page is hard-reloaded, then it probably already have latest version
	          // but it's not controlled by SW yet. Applying update will claim this page
	          // to be controlled by SW. Maybe set flag to not reload it?
	          // if (!navigator.serviceWorker.controller) return;
	
	          handleUpdating(reg);
	          reg.onupdatefound = function() {
	            handleUpdating(reg);
	          };
	        }).catch(function(err) {
	          sendEvent('onError');
	          return Promise.reject(err);
	        });
	      
	
	      return;
	    }
	  
	
	  
	}
	
	function applyUpdate(callback, errback) {
	  
	    if (hasSW()) {
	      navigator.serviceWorker.getRegistration().then(function(registration) {
	        if (!registration || !registration.waiting) {
	          errback && errback();
	          return;
	        }
	
	        registration.waiting.postMessage({
	          action: 'skipWaiting'
	        });
	
	        callback && callback();
	      });
	
	      return;
	    }
	  
	
	  
	}
	
	exports.install = install;
	exports.applyUpdate = applyUpdate;

/***/ },

/***/ 550:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollBehavior = __webpack_require__(581);
	
	var _ScrollBehavior2 = _interopRequireDefault(_ScrollBehavior);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  shouldUpdateScroll: _react2.default.PropTypes.func,
	  routerProps: _react2.default.PropTypes.object.isRequired,
	  children: _react2.default.PropTypes.element.isRequired
	};
	
	var childContextTypes = {
	  scrollBehavior: _react2.default.PropTypes.object.isRequired
	};
	
	var ScrollBehaviorContext = function (_React$Component) {
	  _inherits(ScrollBehaviorContext, _React$Component);
	
	  function ScrollBehaviorContext(props, context) {
	    _classCallCheck(this, ScrollBehaviorContext);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var routerProps = props.routerProps;
	
	
	    _this.scrollBehavior = new _ScrollBehavior2.default(routerProps.router, function () {
	      return _this.props.routerProps.location;
	    }, _this.shouldUpdateScroll);
	
	    _this.scrollBehavior.updateScroll(null, routerProps);
	    return _this;
	  }
	
	  ScrollBehaviorContext.prototype.getChildContext = function getChildContext() {
	    return {
	      scrollBehavior: this
	    };
	  };
	
	  ScrollBehaviorContext.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var routerProps = this.props.routerProps;
	
	    var prevRouterProps = prevProps.routerProps;
	
	    if (routerProps.location === prevRouterProps.location) {
	      return;
	    }
	
	    this.scrollBehavior.updateScroll(prevRouterProps, routerProps);
	  };
	
	  ScrollBehaviorContext.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.scrollBehavior.stop();
	  };
	
	  ScrollBehaviorContext.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollBehaviorContext;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	    var shouldUpdateScroll = _this2.props.shouldUpdateScroll;
	
	    if (!shouldUpdateScroll) {
	      return true;
	    }
	
	    // Hack to allow accessing scrollBehavior.readPosition().
	    return shouldUpdateScroll.call(_this2.scrollBehavior, prevRouterProps, routerProps);
	  };
	
	  this.registerElement = function (key, element, shouldUpdateScroll) {
	    _this2.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this2.props.routerProps);
	  };
	
	  this.unregisterElement = function (key) {
	    _this2.scrollBehavior.unregisterElement(key);
	  };
	};
	
	ScrollBehaviorContext.propTypes = propTypes;
	ScrollBehaviorContext.childContextTypes = childContextTypes;
	
	exports.default = ScrollBehaviorContext;
	module.exports = exports['default'];

/***/ },

/***/ 551:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useScroll;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollBehaviorContext = __webpack_require__(550);
	
	var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useScroll(shouldUpdateScroll) {
	  return {
	    renderRouterContext: function renderRouterContext(child, props) {
	      return _react2.default.createElement(
	        _ScrollBehaviorContext2.default,
	        {
	          shouldUpdateScroll: shouldUpdateScroll,
	          routerProps: props
	        },
	        child
	      );
	    }
	  };
	}
	module.exports = exports['default'];

/***/ },

/***/ 581:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _off = __webpack_require__(155);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _on = __webpack_require__(90);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _scrollLeft = __webpack_require__(157);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _scrollTop = __webpack_require__(58);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _requestAnimationFrame = __webpack_require__(93);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _Actions = __webpack_require__(32);
	
	var _DOMStateStorage = __webpack_require__(95);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-underscore-dangle */
	
	// FIXME: Stop using this gross hack. This won't collide with any actual
	// history location keys, but it's dirty to sneakily use the same storage here.
	var KEY_PREFIX = 's/';
	
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	var ScrollBehavior = function () {
	  function ScrollBehavior(history, getCurrentLocation, shouldUpdateScroll) {
	    var _this = this;
	
	    _classCallCheck(this, ScrollBehavior);
	
	    this._onWindowScroll = function () {
	      // It's possible that this scroll operation was triggered by what will be a
	      // `POP` transition. Instead of updating the saved location immediately, we
	      // have to enqueue the update, then potentially cancel it if we observe a
	      // location update.
	      if (_this._saveWindowPositionHandle === null) {
	        _this._saveWindowPositionHandle = (0, _requestAnimationFrame2.default)(_this._saveWindowPosition);
	      }
	
	      if (_this._windowScrollTarget) {
	        var _windowScrollTarget = _this._windowScrollTarget;
	        var xTarget = _windowScrollTarget[0];
	        var yTarget = _windowScrollTarget[1];
	
	        var x = (0, _scrollLeft2.default)(window);
	        var y = (0, _scrollTop2.default)(window);
	
	        if (x === xTarget && y === yTarget) {
	          _this._windowScrollTarget = null;
	          _this._cancelCheckWindowScroll();
	        }
	      }
	    };
	
	    this._saveWindowPosition = function () {
	      _this._saveWindowPositionHandle = null;
	
	      _this._savePosition(null, window);
	    };
	
	    this._checkWindowScrollPosition = function () {
	      _this._checkWindowScrollHandle = null;
	
	      // We can only get here if scrollTarget is set. Every code path that unsets
	      // scroll target also cancels the handle to avoid calling this handler.
	      // Still, check anyway just in case.
	      /* istanbul ignore if: paranoid guard */
	      if (!_this._windowScrollTarget) {
	        return;
	      }
	
	      var _windowScrollTarget2 = _this._windowScrollTarget;
	      var x = _windowScrollTarget2[0];
	      var y = _windowScrollTarget2[1];
	
	      window.scrollTo(x, y);
	
	      ++_this._numWindowScrollAttempts;
	
	      /* istanbul ignore if: paranoid guard */
	      if (_this._numWindowScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	        _this._windowScrollTarget = null;
	        return;
	      }
	
	      _this._checkWindowScrollHandle = (0, _requestAnimationFrame2.default)(_this._checkWindowScrollPosition);
	    };
	
	    this._history = history;
	    this._getCurrentLocation = getCurrentLocation;
	    this._shouldUpdateScroll = shouldUpdateScroll;
	
	    // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if ('scrollRestoration' in window.history) {
	      this._oldScrollRestoration = window.history.scrollRestoration;
	      window.history.scrollRestoration = 'manual';
	    } else {
	      this._oldScrollRestoration = null;
	    }
	
	    this._saveWindowPositionHandle = null;
	    this._checkWindowScrollHandle = null;
	    this._windowScrollTarget = null;
	    this._numWindowScrollAttempts = 0;
	
	    this._scrollElements = {};
	
	    // We have to listen to each window scroll update rather than to just
	    // location updates, because some browsers will update scroll position
	    // before emitting the location change.
	    (0, _on2.default)(window, 'scroll', this._onWindowScroll);
	
	    this._unlistenBefore = history.listenBefore(function () {
	      if (_this._saveWindowPositionHandle !== null) {
	        _requestAnimationFrame2.default.cancel(_this._saveWindowPositionHandle);
	        _this._saveWindowPositionHandle = null;
	      }
	
	      // It's fine to save element scroll positions here, though; the browser
	      // won't modify them.
	      Object.keys(_this._scrollElements).forEach(function (key) {
	        _this._saveElementPosition(key);
	      });
	    });
	  }
	
	  ScrollBehavior.prototype.stop = function stop() {
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if (this._oldScrollRestoration) {
	      window.history.scrollRestoration = this._oldScrollRestoration;
	    }
	
	    (0, _off2.default)(window, 'scroll', this._onWindowScroll);
	    this._cancelCheckWindowScroll();
	
	    this._unlistenBefore();
	  };
	
	  ScrollBehavior.prototype.registerElement = function registerElement(key, element, shouldUpdateScroll, context) {
	    !!this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is already an element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    this._scrollElements[key] = { element: element, shouldUpdateScroll: shouldUpdateScroll };
	    this._updateElementScroll(key, null, context);
	  };
	
	  ScrollBehavior.prototype.unregisterElement = function unregisterElement(key) {
	    !this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is no element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    delete this._scrollElements[key];
	  };
	
	  ScrollBehavior.prototype.updateScroll = function updateScroll(prevContext, context) {
	    var _this2 = this;
	
	    this._updateWindowScroll(prevContext, context);
	
	    Object.keys(this._scrollElements).forEach(function (key) {
	      _this2._updateElementScroll(key, prevContext, context);
	    });
	  };
	
	  ScrollBehavior.prototype.readPosition = function readPosition(location, key) {
	    return (0, _DOMStateStorage.readState)(this._getKey(location, key));
	  };
	
	  ScrollBehavior.prototype._cancelCheckWindowScroll = function _cancelCheckWindowScroll() {
	    if (this._checkWindowScrollHandle !== null) {
	      _requestAnimationFrame2.default.cancel(this._checkWindowScrollHandle);
	      this._checkWindowScrollHandle = null;
	    }
	  };
	
	  ScrollBehavior.prototype._saveElementPosition = function _saveElementPosition(key) {
	    var element = this._scrollElements[key].element;
	
	
	    this._savePosition(key, element);
	  };
	
	  ScrollBehavior.prototype._savePosition = function _savePosition(key, element) {
	    // We have to directly update `DOMStateStorage`, because actually updating
	    // the location could cause e.g. React Router to re-render the entire page,
	    // which would lead to observably bad scroll performance.
	    (0, _DOMStateStorage.saveState)(this._getKey(this._getCurrentLocation(), key), [(0, _scrollLeft2.default)(element), (0, _scrollTop2.default)(element)]);
	  };
	
	  ScrollBehavior.prototype._getKey = function _getKey(location, key) {
	    // Use fallback location key when actual location key is unavailable.
	    var locationKey = location.key || this._history.createHref(location);
	
	    return key == null ? '' + KEY_PREFIX + locationKey : '' + KEY_PREFIX + key + '/' + locationKey;
	  };
	
	  ScrollBehavior.prototype._updateWindowScroll = function _updateWindowScroll(prevContext, context) {
	    // Whatever we were doing before isn't relevant any more.
	    this._cancelCheckWindowScroll();
	
	    this._windowScrollTarget = this._getScrollTarget(null, this._shouldUpdateScroll, prevContext, context);
	
	    // Check the scroll position to see if we even need to scroll. This call
	    // will unset _windowScrollTarget if the current scroll position matches
	    // the target.
	    this._onWindowScroll();
	
	    if (!this._windowScrollTarget) {
	      return;
	    }
	
	    // Updating the window scroll position is really flaky. Just trying to
	    // scroll it isn't enough. Instead, try to scroll a few times until it
	    // works.
	    this._numWindowScrollAttempts = 0;
	    this._checkWindowScrollPosition();
	  };
	
	  ScrollBehavior.prototype._updateElementScroll = function _updateElementScroll(key, prevContext, context) {
	    var _scrollElements$key = this._scrollElements[key];
	    var element = _scrollElements$key.element;
	    var shouldUpdateScroll = _scrollElements$key.shouldUpdateScroll;
	
	
	    var scrollTarget = this._getScrollTarget(key, shouldUpdateScroll, prevContext, context);
	    if (!scrollTarget) {
	      return;
	    }
	
	    // Unlike with the window, there shouldn't be any flakiness to deal with
	    // here.
	    var x = scrollTarget[0];
	    var y = scrollTarget[1];
	
	    (0, _scrollLeft2.default)(element, x);
	    (0, _scrollTop2.default)(element, y);
	  };
	
	  ScrollBehavior.prototype._getScrollTarget = function _getScrollTarget(key, shouldUpdateScroll, prevContext, context) {
	    var scrollTarget = shouldUpdateScroll ? shouldUpdateScroll.call(this, prevContext, context) : true;
	
	    if (!scrollTarget || Array.isArray(scrollTarget)) {
	      return scrollTarget;
	    }
	
	    var location = this._getCurrentLocation();
	    if (location.action === _Actions.PUSH) {
	      return [0, 0];
	    }
	
	    return this.readPosition(location, key) || [0, 0];
	  };
	
	  return ScrollBehavior;
	}();
	
	exports.default = ScrollBehavior;
	module.exports = exports['default'];

/***/ }

});


// WEBPACK FOOTER //
// app-4e46630900d8847b31b1.js